'use client';

import Grid from '@enlighten/design-system/dist/Grid';
import List from '@enlighten/design-system/dist/List';
import ListItem from '@enlighten/design-system/dist/ListItem';
import ListItemButton from '@enlighten/design-system/dist/ListItemButton';
import Typography from '@enlighten/design-system/dist/Typography';
import Image from 'next/image';
import { useEffect, useState } from 'react';

import NamsanImg from '@/assets/images/members/namsan.png';

import type { ITutorialStepComponent } from '..';

export default function Prepare({ onChangeComponent }: ITutorialStepComponent) {
	const [mounted, setMounted] = useState<boolean>(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	return (
		<Grid
			container
			direction="column"
			gap={2}
			width="100%"
			padding={{ xs: '52px 24px', md: '80px 80px 140px 80px' }}
			sx={{
				opacity: mounted ? 1 : 0,
				transform: `translateX(${mounted ? 0 : 50}px)`,
				transition: 'transform 0.5s ease, opacity 0.3s ease',
				'& img': {
					width: { xs: 56, md: 72 },
					height: { xs: 56, md: 72 },
				},
			}}
		>
			<Image src={NamsanImg} alt="namsan" priority />
			<Typography fontSize={{ xs: 26, md: 34 }} fontWeight={700} lineHeight={{ xs: 1.3, md: '44px' }} marginBottom={2}>
				{'안녕하세요 고객님,\n태양광을 준비중이신가요?'}
			</Typography>
			<List
				disablePadding
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: 2,
				}}
			>
				{[
					{
						title: '네, 태양광 사업을 시작하고 싶습니다.',
						onClick() {
							onChangeComponent('business');
						},
					},
					{
						title: '이미 발전소를 운영중입니다.',
						onClick() {
							onChangeComponent('owner');
						},
					},
					{
						title: 'RE100 이행을 준비중입니다.',
						onClick() {
							onChangeComponent('re100');
						},
					},
					{
						title: '시공사를 위한 상품을 보고 싶어요',
						onClick() {
							onChangeComponent('product');
						},
					},
				].map(({ title, onClick }, i) => (
					<ListItem key={i} disablePadding disableGutters>
						<ListItemButton
							onClick={onClick}
							sx={(theme) => ({
								border: `1px solid ${theme.palette.grey['400']}`,
								borderRadius: 1,
								height: 68,
								padding: '20px 24px',
								cursor: 'pointer',
								transition: 'all 0.2s ease',
								':hover': {
									bgcolor: '#F9F6FF',
									borderColor: 'primary.light',
									'.MuiTypography-root': {
										color: 'primary.light',
										fontWeight: 700,
									},
								},
								'.MuiTypography-root': {
									transition: 'all 0.2s ease',
								},
							})}
						>
							<Typography fontSize={16}>{title}</Typography>
						</ListItemButton>
					</ListItem>
				))}
			</List>
		</Grid>
	);
}
